import { useQuery } from '@tanstack/react-query';
import { api } from './utils/api-base';

export const useFetchCheckoutSessionUrl = <Params>(params: Params) => {
  return useQuery<string>({
    queryKey: ['use-fetch-checkout-session-url', params],
    queryFn: async () => {
      const response = await api.get<string>('checkout/session_url', {
        params,
      });

      return response.data;
    },
    staleTime: 10 * 60 * 1000,
  });
};
